import React from 'react';
import { PropertyGroup } from '../PropertyGroup';
import { PropertyNumber } from '../property-types/PropertyNumber';

interface EffectsData {
  opacity: number;
}

interface EffectsGroupProps {
  effects: EffectsData;
  onEffectsChange: (property: keyof EffectsData, value: number) => void;
}

export const EffectsGroup: React.FC<EffectsGroupProps> = ({
  effects,
  onEffectsChange
}) => {
  return (
    <PropertyGroup title="Effects">
      {/* Opacity */}
      <div className="flex items-center gap-2 py-0.5 mt-1">
        <span className="text-gray-900 dark:text-white text-sm font-medium w-[30%] flex-shrink-0">Opacity</span>
        <div className="flex flex-1 gap-2">
          <PropertyNumber
            label=""
            value={effects.opacity}
            onChange={(value) => onEffectsChange('opacity', value)}
            step={0.01}
            min={0}
            max={1}
          />
        </div>
      </div>
    </PropertyGroup>
  );
};

